import { useGlobalNotification } from "@/entities/set-global-notification/fetch";
import { useCallback, useState } from "react";
import type { ExpirableFileOpenerProps } from "../model";

export const useExpirableFileOpenerProps = (
  url: string,
  filename: string,
): ExpirableFileOpenerProps => {
  const [isLoading, setIsLoading] = useState(false);
  const { setGlobalNotification } = useGlobalNotification();

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    try {
      // HEADリクエストでファイルの有効性を確認
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
      });

      if (response.ok) {
        // ファイルが有効な場合、新しいタブで開く
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        // エラーステータスの場合
        let errorMessage: string;
        if (response.status === 403) {
          errorMessage =
            "ファイルの表示ができませんでした。ページを再読み込みしてもう一度試してみてください。";
        } else if (response.status === 404) {
          errorMessage =
            "ファイルが見つかりませんでした。XMileサポートまでお問い合わせください。";
        } else {
          errorMessage = `ファイルのダウンロードができませんでした。XMileサポートまでお問い合わせください (エラーコード: ${response.status})`;
        }

        setGlobalNotification({
          message: errorMessage,
          variant: "error",
          autoHide: true,
        });
      }
    } catch (error) {
      console.error("ファイルアクセスエラー:", error);

      setGlobalNotification({
        message:
          "ファイルの表示ができませんでした。ページを再読み込みしてもう一度試してみてください。",
        variant: "error",
        autoHide: true,
      });
    } finally {
      setIsLoading(false);
    }
  }, [url, setGlobalNotification]);

  return {
    url,
    filename,
    handleClick,
    isLoading,
  };
};
